var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgIos = function SvgIos(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 24c0 11.592-9.398 21-21 21S3 35.592 3 24C3 12.398 12.398 3 24 3s21 9.398 21 21Z",
    fill: "#283544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.629 31.259h2.294V20.616h-2.294V31.26Zm1.142-12.038c.71 0 1.28-.602 1.28-1.355 0-.774-.57-1.366-1.28-1.366-.7 0-1.271.592-1.271 1.366 0 .753.571 1.355 1.271 1.355ZM20.936 16.53c-3.878 0-6.31 2.882-6.31 7.49 0 4.608 2.432 7.48 6.31 7.48 3.87 0 6.301-2.872 6.301-7.48 0-4.608-2.432-7.49-6.3-7.49Zm0 2.209c2.368 0 3.878 2.048 3.878 5.281 0 3.223-1.51 5.271-3.878 5.271-2.376 0-3.878-2.048-3.878-5.27 0-3.234 1.502-5.282 3.878-5.282ZM28.591 27.183c.101 2.67 2.11 4.317 5.168 4.317 3.215 0 5.241-1.727 5.241-4.478 0-2.159-1.142-3.373-3.841-4.046l-1.53-.382c-1.63-.421-2.302-.984-2.302-1.947 0-1.205 1.013-2.008 2.515-2.008 1.52 0 2.56.813 2.67 2.168h2.267c-.055-2.55-1.99-4.277-4.919-4.277-2.892 0-4.947 1.737-4.947 4.307 0 2.069 1.161 3.354 3.611 3.966l1.723.442c1.676.432 2.358 1.034 2.358 2.078 0 1.205-1.114 2.069-2.717 2.069-1.621 0-2.847-.874-2.994-2.21h-2.303Z",
    fill: "#fff"
  })));
};

export default SvgIos;